import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Form } from 'react-final-form';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { CircularProgress } from '@mui/material';
import { Input } from '../../components/Form';
import { FileUpload } from '../../components/UploadFile';
import { IGroup } from '../../api/groups';
import { INewsItem } from '../../api/news';
import { BackDrop } from '../../components/Utils/BackDrop';


const useStyles = makeStyles((theme) => ({
    root: {},
    media: {
        height: 150,
        marginBottom: theme.spacing(2),
    },
}));

interface IProps {
    item: INewsItem;
    groups: IGroup[];
    save: any;
    saving: boolean;
    uploading: boolean;
    remove: any;
    removing: boolean;
    onChangeMediaInput: Function;
}
function MediaDetails({ values, onChangeMediaInput }: IProps & { values: any }) {
    const classes = useStyles()

    return (
        <>
            <FileUpload updateFilesCb={onChangeMediaInput('video')}
                accept="video/*"
                label="видео"
                labelToUpload={`Видео 9:16 [2160px * 3840px]`}
                labelUploaded="Загруженное видео"
                preview={values.video && (
                    <video src={values.video}
                        className={classes.media}
                        autoPlay={false}
                        playsInline={true}
                        muted={true}
                        disablePictureInPicture={true}
                        controls={true} />
                )}>
                <Input name="video"
                    label="Видео (URL)"
                    margin="normal"
                    placeholder="9:16 [2160px * 3840px]"
                    emptyAsNull />
            </FileUpload>

            <FileUpload updateFilesCb={onChangeMediaInput('image')}
                accept="image/*"
                label="изображение"
                labelToUpload={`Изображение [1080px * 840px] или [2160px * 1680px]`}
                labelUploaded="Загруженное изображение"
                preview={values.image && (
                    <img src={values.image} className={classes.media} alt="" />
                )}>
                <Input name="image"
                    label="Изображение (URL)"
                    margin="normal"
                    placeholder="[1080px * 840px] или [2160px * 1680px]" />
            </FileUpload>

            <FileUpload updateFilesCb={onChangeMediaInput('feedImage')}
                accept="image/*"
                label="изображение для ленты"
                labelToUpload={`Изображение для ленты [350px * 290px] или [700px * 580px]`}
                labelUploaded="Загруженное изображение для ленты"
                preview={values.feedImage && (
                    <img src={values.feedImage} className={classes.media} alt="" />
                )}>
                <Input name="feedImage"
                    label="Изображение (URL) для ленты"
                    margin="normal"
                    placeholder="[350px * 290px] или [700px * 580px]" />
            </FileUpload>
        </>
    );
}

export const NewsMedia = (props: IProps) => {
    const {
        onChangeMediaInput,
        item,
        groups,
        save,
        saving,
        uploading,
        remove,
        removing,
    } = props;

    const initial = {
        ...item,
        groups: item.groups?.map((g) => g.id),
    };

    const onSubmit = (values: any) => {
        save({
            ...values,
            groups: values.groups.map((id: number) => ({ id })),
            id: item.id,
        });
    };

    return (
        <Form onSubmit={onSubmit} initialValues={initial} render={({ handleSubmit, values }) => (
            <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
                {uploading && (
                    <BackDrop>
                        <CircularProgress />
                        <br />
                        Загрузка файлов...
                    </BackDrop>
                )}

                <MediaDetails {...props} values={values} />

                <Grid container justify="space-between" style={{ position: 'sticky', bottom: 0 }}>
                    <Grid item>
                        <Box my={2}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="large"
                                disabled={saving}
                            >
                                Сохранить
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        )} />
    );
}